module.exports = __webpack_public_path__ + "img/myS.aa3afb2b.png";